// extracted by mini-css-extract-plugin
module.exports = {"terminal":"theme_terminal__3-lFo","promptUser":"theme_promptUser__rwHEM","promptPath":"theme_promptPath__-9nnr","error":"theme_error__2BWS5","bold":"theme_bold__ADbgu"};